declare module "@mui/material/styles" {
  interface Shape {
    borderRadius: number | string;
    borderRadiusSm: number | string;
    borderRadiusMd: number | string;
    borderRadiusXs: number | string;
  }
}

const shape = {
  borderRadius: 4,
  borderRadiusSm: 2,
  borderRadiusXs: 1,
  borderRadiusMd: 6,
};

export default shape;
